import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("As senhas não coincidem");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Senha redefinida! Faça login com a nova senha.");
      navigate("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Falha ao redefinir senha");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 p-6">
      <Card className="w-full max-w-md p-8 rounded-2xl border-stone-200">
        <Link to="/" className="inline-flex items-center gap-2 mb-6">
          <img src="/logo.png" alt="Ultra" className="h-8 w-8 rounded-md" />
          <span className="font-display text-lg font-extrabold">Ultra</span>
        </Link>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Nova senha</h1>
        <p className="font-body text-sm text-stone-500 mt-2">
          Crie uma nova senha para sua conta.
        </p>
        {!token ? (
          <p className="mt-6 text-sm text-rose-700 font-body" data-testid="reset-no-token">
            Link inválido. Solicite uma nova recuperação em{" "}
            <Link to="/forgot-password" className="underline font-semibold">
              recuperar senha
            </Link>
            .
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="mt-6 space-y-4" data-testid="reset-form">
            <div>
              <Label className="font-body text-sm">Nova senha</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                data-testid="reset-password"
                className="mt-1.5 bg-white"
              />
            </div>
            <div>
              <Label className="font-body text-sm">Confirmar nova senha</Label>
              <Input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                minLength={6}
                data-testid="reset-confirm"
                className="mt-1.5 bg-white"
              />
            </div>
            <Button
              type="submit"
              disabled={submitting}
              data-testid="reset-submit"
              className="w-full bg-emerald-800 hover:bg-emerald-900 text-white h-11 font-body"
            >
              {submitting ? "Salvando..." : "Redefinir senha"}
            </Button>
          </form>
        )}
      </Card>
    </div>
  );
}
